import { CardLoader } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'
import { PaymentMethodPagination } from 'domains/payment-method/components'
import RefundPaymentTableRow from './refund-payment-table-row'

const propTypes = {
  tableProps            : PropTypes.object,
  refundPayments        : PropTypes.array,
  pagination            : PropTypes.object,
  onPageChange          : PropTypes.func,
  isLoading             : PropTypes.bool,
  onClickChangeIsActive : PropTypes.func,
  onClickDetail         : PropTypes.func
}

const defaultProps = {
  isLoading: true
}

/**
 * Table to display specific ::RefundPaymeny columns
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onPageChange - function that will handle Page Change
 * @param {Boolean} isLoading - boolean for withLoader animation
 */

const RefundPaymentTable = ({
  tableProps,
  refundPayments,
  pagination,
  isLoading,
  onPageChange
}) => {

  const totalColumns         = 8
  const isRefundPaymentEmpty = refundPayments.length === 0

  const TableContent = () => (
    <Table { ...tableProps }>
      <thead className='bg-white'>
        <tr>
          <th scope="col">Order Number</th>
          <th scope="col">Transaction No.</th>
          <th scope="col">Bank Holder Name</th>
          <th scope="col">Transfer Method</th>
          <th scope="col">Status</th>
          <th scope="col">Bank Name</th>
          <th scope="col">Account Number</th>
          <th scope="col">action</th>
        </tr>
      </thead>
      <tbody className='bg-white'>
        {
          refundPayments.map((payment) => (
            <RefundPaymentTableRow
              key={ `RefundPaymentTableRow-${payment.id}` }
              refundPayment={ payment }
            />
          ))
        }
        {
          isRefundPaymentEmpty && (
            <tr>
              <td
                colSpan={ totalColumns }
                className='bg-warning text-white'
              >
                <i className='fas fa-info-circle mr-3' />
                { 'No Refund Payment found based on your filters.' }
              </td>
            </tr>
          )
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <PaymentMethodPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
      <TableContentWithLoader isLoading= { isLoading } />

      <PaymentMethodPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}


RefundPaymentTable.propTypes    = propTypes
RefundPaymentTable.defaultProps = defaultProps

export default RefundPaymentTable
